import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Utils } from "../../utils/utils";
import { Stakeholder } from "../../interfaces/questionnaire";

@Component({
  selector: "app-add-stakeholder-dialog",
  templateUrl: "./add-stakeholder-dialog.component.html",
  styleUrls: ["./add-stakeholder-dialog.component.scss"],
})
export class AddStakeholderDialogComponent
  extends MzBaseModal
  implements OnInit, OnChanges {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() stakeholders: Stakeholder[];
  @Input() allStakeholders: string[];

  @Output()
  createStakeholderClicked: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("NameInput") NameInput: ElementRef;

  autocomplete = {};
  newStakeholder: Stakeholder;
  canCreate: boolean;
  error: string;

  constructor() {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.newStakeholder = {} as Stakeholder;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["allStakeholders"]) {
      this.autocomplete = {
        data: (this.allStakeholders || []).reduce((x, n) => {
          x[n] = null;
          return x;
        }, {}),
      };
    }
  }

  async validate(newValue) {
    let nameNotEmpty = newValue && newValue.trim() !== "";
    this.canCreate = nameNotEmpty;
    this.error = null;
  }

  /**
   * creates new Item
   */
  createStakeholder() {
    if (this.canCreate) {
      this.newStakeholder.name = this.NameInput.nativeElement.value;
      this.createStakeholderClicked.emit(this.newStakeholder);
      this.newStakeholder = {} as Stakeholder;
      this.NameInput.nativeElement.value = null;
      this.canCreate = false;
      this.error = null;
    }
  }

  /**
   * resets newItem object and closes modal
   * @param modal
   */
  closeSprintModal() {
    this.newStakeholder = {} as Stakeholder;
    this.NameInput.nativeElement.value = null;
    this.canCreate = false;
    this.error = null;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/add-stakeholder-dialog/add-stakeholder-dialog.component.ts